import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TiimeIconModule } from 'tiime-material';

import { PcgEntry } from '@models/pcg-entry';
import { PcgEntryDescriptionPipe } from '@modules/shared/pipes/pcg-entry-description/pcg-entry-description.pipe';

@Component({
  selector: 'app-pcg-entry-option',
  standalone: true,
  imports: [TiimeIconModule, PcgEntryDescriptionPipe],
  templateUrl: './pcg-entry-option.component.html',
  styleUrls: ['./pcg-entry-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tiime-option'
  }
})
export class PcgEntryOptionComponent {
  @Input() pcgEntry: PcgEntry;
}
